import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AvatarService } from '@y42/core/avatar';
import * as go from 'gojs';
import { firstValueFrom } from 'rxjs';
import { ChatAvatar, ChatRoomCreationStrategy, ChatRoomUIModel } from '../models/chat-room.model';
import { ChatService } from '../services/chat.service';
import { getNameInitials } from '../utils/get-name-initials';

interface ChatAvatarWithInitials extends ChatAvatar {
  initials?: string;
  bgColor?: string;
}
export interface ChatRoomsAvatarDiagramData {
  chatAuthor?: ChatAvatarWithInitials;
  chatAvatars: Record<string, { createdBy: ChatAvatarWithInitials; chatRoomId?: string }>;
}

export const CHAT_ROOMS_AVATAR_DIAGRAM_DATA_KEY = 'CHAT_ROOMS_AVATAR_DATA';

@UntilDestroy()
@Injectable()
export class ChatPinsDataHelperService {
  constructor(private readonly chatService: ChatService, private readonly avatarService: AvatarService) {}

  public getChatCanvasConfigFor(entityFilePath: string) {
    return {
      key: `chat-room-git-entity-${entityFilePath}`,
      target: 'canvas',
      strategy: 'multiple' as ChatRoomCreationStrategy,
    };
  }

  public async setAvatarsDataInDiagramModelData(chatRooms: ChatRoomUIModel[], diagram: go.Diagram) {
    const chatAvatars = (chatRooms || []).reduce((acc, curr) => {
      if (curr.metadata?.uiId) {
        acc[curr.metadata.uiId] = {
          createdBy: {
            ...curr.createdBy,
            initials: getNameInitials(curr.createdBy.full_name),
            bgColor: this.avatarService.getRandomColor(curr.createdBy.full_name),
          },
          chatRoomId: curr.id,
        };
      }
      return acc;
    }, {} as Record<string, { createdBy: ChatAvatarWithInitials; chatRoomId?: string }>);
    const chatAuthor = (await firstValueFrom(this.chatService.chatAuthor$)) || undefined;

    const chatAuthorWithInitials: ChatAvatarWithInitials = {
      ...chatAuthor,
      initials: getNameInitials(chatAuthor.full_name),
      bgColor: this.avatarService.getRandomColor(chatAuthor.full_name),
    };

    const avatars: ChatRoomsAvatarDiagramData = { chatAuthor: chatAuthorWithInitials, chatAvatars };
    diagram?.model.set(diagram.model.modelData, CHAT_ROOMS_AVATAR_DIAGRAM_DATA_KEY, avatars);
  }
}
